import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class DropdownService {

  isOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

  toggle(): void {
    this.isOpened.next(!this.isOpenedValue);
  }

  get isOpenedValue(): boolean {
    return this.isOpened.getValue();
  }

  show(): void {
    if (!this.isOpenedValue) {
      this.isOpened.next(true);
    }
  }

  close(): void {
    if (this.isOpenedValue) {
      this.isOpened.next(false);
    }
  }

}
